import { motion, useReducedMotion } from "framer-motion";
import WovenPattern from "./WovenPattern";

/**
 * Consistent inner-page hero with the woven motif and a masked heading reveal.
 */
export const PageHeader = ({ eyebrow, title, intro, testId }) => {
  const reduce = useReducedMotion();
  return (
    <section className="relative overflow-hidden woven-texture" data-testid={testId}>
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-70">
        <WovenPattern opacity={0.15} />
      </div>
      <div className="relative mx-auto max-w-6xl px-5 py-20 md:px-8 md:py-24">
        {eyebrow && (
          <p className="mb-5 text-sm font-semibold uppercase tracking-[0.22em] text-melt-amber">{eyebrow}</p>
        )}
        <h1 className="max-w-4xl overflow-hidden font-serif text-4xl font-semibold leading-[1.1] text-[#FAF8F5] sm:text-5xl">
          <motion.span
            className="block"
            initial={reduce ? false : { y: "110%" }}
            animate={reduce ? {} : { y: "0%" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.05 }}
          >
            {title}
          </motion.span>
        </h1>
        {intro && (
          <motion.p
            className="mt-6 max-w-2xl text-lg leading-relaxed text-[#FAF8F5]/85"
            initial={reduce ? false : { opacity: 0, y: 16 }}
            animate={reduce ? {} : { opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.35 }}
          >
            {intro}
          </motion.p>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
